// F1 — אייקוני-כיוון.
//
// ★★ **הכלל שנקבע (בקשת-משתמש 27/07): אייקוני-הניווט של המסגרת נשארים בדיוק
//    כמו בעברית — אותו צד פיזי ואותו גליף — בכל חמש השפות.**
//    זהו אותו עיקרון שהוחל כבר על בורר-השפה (תמיד ימין) ועל שורת-הזכויות
//    (תמיד שמאל): המסגרת יציבה, רק הטקסט מתחלף.
//
// ⚠️ למה זה דורש קוד ולא "לא לעשות כלום": ‏MUI מזיז את `startIcon`/`endIcon`
//    לפי `theme.direction`. אותה הצהרה בדיוק שנותנת "חץ מימין" בעברית נותנת
//    "חץ משמאל" באנגלית. כדי שהצד ה**פיזי** יישאר קבוע צריך להחליף בין
//    ‏`startIcon` ל-`endIcon` יחד עם הכיווניות — וזה מה שהעוזרים כאן עושים.
//
// ★ השברון של "שלב הבא"/"לפרטים" (‏useForwardChevron) **כן** מתהפך: הוא
//   מסמן התקדמות בזרימת-הקריאה, ולכן באנגלית הוא צריך להצביע ימינה. המשתמש
//   ביקש לקבע רק את שני אייקוני-המסגרת (חזרה והתנתקות).

import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useI18n } from './index';

/**
 * ה-props של אייקון כפתור "חזרה".
 *
 * בעברית: ‏`startIcon` ⇒ מרונדר מימין לטקסט, גליף `›`.
 * ⇒ כדי לשמר את אותו מראה ב-LTR צריך `endIcon` (שם הוא מרונדר מימין),
 *   עם אותו גליף בדיוק.
 *
 * שימוש:  ‏`<Button {...useBackIconProps()}>{t('common.back')}</Button>`
 */
export function useBackIconProps() {
  const { dir } = useI18n();
  const icon = <ArrowForwardIosIcon />;
  return dir === 'rtl' ? { startIcon: icon } : { endIcon: icon };
}

/**
 * ה-props של אייקון כפתור "התנתקות".
 *
 * בעברית: ‏`endIcon` ⇒ מרונדר משמאל לטקסט.
 * ⇒ ב-LTR צריך `startIcon` כדי להישאר משמאל.
 *
 * ★ הגליף עצמו (דלת + חץ) מסובב אופקית **בכל השפות** דרך CSS ב-Header.css,
 *   כך שהחץ תמיד יוצא מהדלת שמאלה — לכיוון שאליו הכפתור מצביע.
 */
export function useLogoutIconProps(icon) {
  const { dir } = useI18n();
  return dir === 'rtl' ? { endIcon: icon } : { startIcon: icon };
}

/**
 * שברון "המשך/כניסה" — מצביע **עם** כיוון הקריאה, ולכן כן מתהפך.
 * RTL: ‏‹  ·  LTR: ‏›
 */
export function useForwardChevron() {
  const { dir } = useI18n();
  return dir === 'rtl' ? ChevronLeftRoundedIcon : ChevronRightRoundedIcon;
}
